import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/platform', label: 'Platform' },
    { path: '/stay-informed', label: 'Stay Informed' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 w-full z-50 bg-[#0A0A0A]/95 backdrop-blur-md border-b border-[#DAA520]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group" data-testid="nav-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_jailer-campaign/artifacts/yph5ki0r_MC_Jailer_Logo_TR.png"
              alt="Barry Howell for Marshall County Jailer"
              className="h-10 sm:h-14 w-auto group-hover:scale-105 transition-transform"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6 xl:gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
                className={`text-sm font-bold uppercase tracking-[0.15em] transition-colors hover:text-[#DAA520] ${
                  isActive(link.path) ? 'text-[#DAA520]' : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Button 
              onClick={() => window.open('https://www.paypal.com/donate/?hosted_button_id=YMDPJ3HQR2LNL', '_blank')}
              data-testid="nav-donate-btn"
              className="bg-[#DAA520] text-black hover:bg-[#E6B422] font-bold uppercase tracking-wider px-6"
            >
              Donate
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-white hover:text-[#DAA520] transition-colors p-2"
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="lg:hidden py-4 sm:py-6 border-t border-[#DAA520]/20 animate-fadeIn">
            <div className="flex flex-col gap-3 sm:gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
                  className={`text-base font-bold uppercase tracking-wider py-2 transition-colors hover:text-[#DAA520] ${
                    isActive(link.path) ? 'text-[#DAA520]' : 'text-white'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Button 
                onClick={() => window.open('https://www.paypal.com/donate/?hosted_button_id=YMDPJ3HQR2LNL', '_blank')}
                data-testid="mobile-donate-btn"
                className="w-full bg-[#DAA520] text-black hover:bg-[#E6B422] font-bold uppercase tracking-wider mt-2 sm:mt-4"
              >
                Donate
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
